module.exports = __webpack_public_path__ + "img/20191228130641808.a5266d51.jpg";